import { render, staticRenderFns } from "./CustomerStartFromScratch.vue?vue&type=template&id=be0ac738&scoped=true&lang=pug&"
import script from "./CustomerStartFromScratch.vue?vue&type=script&lang=js&"
export * from "./CustomerStartFromScratch.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStartFromScratch.vue?vue&type=style&index=0&id=be0ac738&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0ac738",
  null
  
)

export default component.exports